<script lang="ts" setup>
const { gtm } = useRuntimeConfig().public
const { LocalConfigurationStore } = stores()
const googleTagManegerId =
  LocalConfigurationStore.value?.brokerContext?.context.googleTagManagerId ?? gtm.id
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <PvToast class="z-[9999]" />
    <NotificationsComponent />
    <PvConfirmDialog>
      <template #container="slotProps">
        <div class="grid gap-4 p-6">
          <p>{{ slotProps.message.message }}</p>
          <div class="flex justify-end gap-2">
            <PvButton
              :label="slotProps?.message?.rejectProps?.label ?? 'Cancelar'"
              severity="contrast"
              outlined
              @click="slotProps?.rejectCallback()"
            />
            <PvButton
              :label="slotProps?.message?.acceptProps?.label ?? 'Continuar'"
              @click="slotProps?.acceptCallback()"
            />
          </div>
        </div>
      </template>
    </PvConfirmDialog>
    <ClientOnly>
      <!-- Google Tag Manager (noscript) -->
      <noscript v-if="gtm?.enable && googleTagManegerId">
        <iframe
          :src="`https://www.googletagmanager.com/ns.html?id=${googleTagManegerId}`"
          height="0"
          width="0"
          style="display: none; visibility: hidden"
        >
        </iframe>
      </noscript>
      <!-- End Google Tag Manager (noscript) -->
    </ClientOnly>
  </div>
</template>
